import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SUBSCRIPTION_STATUS: "Status på abonnement",
      STATUS: "aktiv",
      YOUR_SUBSCRIPTION_IS_ACTIVE: "Ditt abonnement er aktivt",
      IF_YOU_WANT_TO_PAUSE_YOUR_SUBSCRIPTION_FOR_A_WEEK_DO_IT_VIA:
        "Hvis du vil pause abonnementet ditt en uke kan du gjøre det via",
      YOUR_DELIVERY_CALENDAR: "din leveringskalender",
      NOTE: "Merk: ",
      ACTIVE_DISCOUNTS: "Aktive rabatter ",
      MAY_BE_LOST_IF_YOU_CANCEL_SUBSCRIPTION:
        "kan gå tapt hvis du sier opp ditt abonnement.",
    },
    se: {
      SUBSCRIPTION_STATUS: "Prenumerationsstatus",
      STATUS: "aktiv",
      YOUR_SUBSCRIPTION_IS_ACTIVE: "Din prenumeration är aktiv.",
      IF_YOU_WANT_TO_PAUSE_YOUR_SUBSCRIPTION_FOR_A_WEEK_DO_IT_VIA:
        "Om du vill hoppa över enskilda leveranser, gör du det via",
      YOUR_DELIVERY_CALENDAR: "din leveranskalender",
      NOTE: "Notera: ",
      ACTIVE_DISCOUNTS: "Aktiva rabatter ",
      MAY_BE_LOST_IF_YOU_CANCEL_SUBSCRIPTION:
        "kan gå förlorade om du avslutar din prenumeration.",
    },
    dk: {
      SUBSCRIPTION_STATUS: "Abonnementsstatus",
      STATUS: "aktiv",
      YOUR_SUBSCRIPTION_IS_ACTIVE: "Dit abonnement er aktivt.",
      IF_YOU_WANT_TO_PAUSE_YOUR_SUBSCRIPTION_FOR_A_WEEK_DO_IT_VIA:
        "Hvis du gerne vil holde pause en enkelt uge, kan du afbestille den pågældende levering via",
      YOUR_DELIVERY_CALENDAR: "din leveringskalender",
      NOTE: "Note: ",
      ACTIVE_DISCOUNTS: "Aktive rabatter ",
      MAY_BE_LOST_IF_YOU_CANCEL_SUBSCRIPTION:
        "kan gå tabt, hvis du opsiger dit abonnement.",
    },
  } as const
)[language];
